<script setup lang="ts">
import type { TabContent } from '@/components/TabCardContainer';

import { TabCardContainer } from '@/components/TabCardContainer';
import { useEvents } from '@/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';

const { trackCardFeatureClicked } = useEvents();

const tabs: TabContent[] = [
	{
		label: 'Quero comprar',
		cards: [
			{
				image: {
					src: '/images/home/exclusivos-pilarhomes.webp',
					alt: 'Exclusivos PilarHomes',
					quality: 80,
					lazy: true
				},
				content: {
					title: 'Exclusivos PilarHomes',
					subtitle: 'Endereços únicos que você não encontra em outro lugar.'
				},
				to: '/venda/imoveis/sao-paulo-sp-brasil?isExclusive=true&cities=S%C3%A3o+Paulo',
				showArrowIcon: true
			},
			{
				image: {
					src: '/images/home/colecoes-compartilhadas.webp',
					alt: 'Coleções Compartilhadas',
					quality: 80,
					lazy: true
				},
				content: {
					title: 'Coleções Compartilhadas',
					subtitle: 'Seu espaço para salvar e dividir imóveis especiais.'
				},
				to: '/colecoes/minha-colecao',
				showArrowIcon: true
			},
			{
				image: {
					src: '/images/home/off-market.webp',
					alt: 'Off-Market',
					quality: 90,
					lazy: true
				},
				content: {
					title: 'Off-Market',
					subtitle: 'Privacidade para imóveis de alto valor não anunciados. '
				},
				to: '/off-market',
				showArrowIcon: true
			}
		]
	},
	{
		label: 'Quero vender',
		cards: [
			{
				image: {
					src: '/images/home/anunciar-imovel.webp',
					alt: 'Anunciar imóvel',
					quality: 90,
					lazy: true
				},
				content: {
					title: 'Anunciar imóvel',
					subtitle: 'Anuncie seu imóvel com quem lidera o segmento.'
				},
				to: '/anunciar-imovel',
				showArrowIcon: true
			},
			{
				image: {
					src: '/images/home/off-market.webp',
					alt: 'Off-Market',
					quality: 90,
					lazy: true
				},
				content: {
					title: 'Off-Market',
					subtitle: 'Exclusividade e sigilo em cada etapa da sua venda.'
				},
				to: '/off-market',
				showArrowIcon: true
			}
		]
	},
	{
		label: 'Sou corretor',
		cards: [
			{
				image: {
					src: '/images/home/parceiro-pilar.webp',
					alt: 'Parceiro Pilar',
					quality: 90,
					lazy: true
				},
				content: {
					title: 'Corretor parceiro',
					subtitle: 'Candidate-se a rede mais produtiva do segmento.'
				},
				to: '/?typeform=lead-broker',
				showArrowIcon: true
			},
			{
				image: {
					src: '/images/home/conheca-a-pilar.webp',
					alt: 'Conheça a pilar',
					quality: 90,
					lazy: true
				},
				content: {
					title: 'Conheça a pilar',
					subtitle: 'Líder em vendas e referência no alto padrão.'
				},
				to: '/sobre-a-pilar',
				showArrowIcon: true
			}
		]
	}
];

function handleCardClick(
	tabIndex: number,
	cardIndex: number,
	event: MouseEvent
) {
	const currentTab = tabs[tabIndex];
	const currentCard = currentTab?.cards?.[cardIndex];

	if (currentTab && currentCard) {
		trackCardFeatureClicked({
			[MixpanelProps.CURRENT_PAGE]: 'HomePage',
			[MixpanelProps.SECTION_NAME]: 'features',
			[MixpanelProps.DESTINATION_URL]: currentCard.to || '',
			[MixpanelProps.CLICK_OWNER]: currentTab.label === 'Quero vender',
			[MixpanelProps.CLICK_FORMER]: currentTab.label === 'Sou corretor',
			[MixpanelProps.CLICK_BUYER]: currentTab.label === 'Quero comprar',
			[MixpanelProps.FEATURE_NAME]: currentCard.content.title
		});
	}
}
</script>

<template>
	<section class="w-full bg-primary">
		<Container class="py-[44px]! pr-0! lg:py-[60px]! lg:pr-12! xl:py-[86px]!">
			<TabCardContainer :tabs="tabs" @card-click="handleCardClick" />
		</Container>
	</section>
</template>
